<template>
    <div>
        <h1>Projects</h1>
        <b-button @click="reload" variant="primary">Reload</b-button>
        <!-- {{ projects }} -->
        <ul>
            <li v-for="project in projects" :key="project.id">{{ project.name }}</li>
        </ul>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    data () {
        return {
            // projects: []
        }
    },
    mounted () {
        // this.$store.dispatch('fetchProjects')
    },
    methods: {
        reload () {
            this.$store.dispatch('fetchProjects')
        }
    },
    computed: {
        ...mapGetters({
            projects: 'projects'
        })
    }
}
</script>